import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import { lazy } from 'react';

const GoogleReviewsPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.owner,
  routes: [
    {
      path: routesUrl.googleReviews,
      component: lazy(() => import('../googleReviews/pages/GoogleReviewsPage')),
    },
  ],
};

export default GoogleReviewsPageConfig;
